/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, {useState } from "react";
import { useNavigate, useParams } from 'react-router-dom';

import { Row, Col, Button, Table } from "react-bootstrap";

import { useAuth } from "../../components/AuthProvider"

import { MM } from "../../engine/model_manager";



function Accounts(props) {
  const results = useAuth();
  const navigate = useNavigate();

  let accounts = results.simResults.simModel.accts;


  function onAddBankAcct(event) {
    event.preventDefault();
    nav('bankaccount');
  }

  function onAddCreditCard(event) {
    event.preventDefault();
    nav('creditcard');
  }

  function onAddLineofCredit(event) {
    event.preventDefault();
    nav('lineofcredit');
  }

  function onAddInvestment(event) {
    event.preventDefault();
    nav('investment');
  }

  function nav(type) {
    navigate(`/app/planner/accounts/add/${type}`);
  }

  function onEdit(acct) {
    let path = `/app/planner/accounts/${acct.baseID}/edit`;
    navigate(path);
  } 

  function onDelete(acct) {
    // TODO check for dependencies then implement
  }
  

  return (
    <>
      <Row>
        <Col xs={3}><h3>Accounts</h3></Col>        
        <Col>
          <Button onClick={onAddBankAcct}><i className="fas fa-plus" title="Add Bank Account"></i>Bank Account</Button>
          <Button onClick={onAddCreditCard}><i className="fas fa-plus" title="Add Credit Card"></i>Credit Card</Button>
          <Button onClick={onAddLineofCredit}><i className="fas fa-plus" title="Add Line of Credit"></i>Line of Credit</Button>
        </Col>
      </Row>
      {accounts.map( (a,i) => <Account key={i} account={a} onEdit={onEdit} onDelete={onDelete} />)}
    </>
  );
}


function Account(props) {

  function onEdit(event) {
    event.preventDefault();
    props.onEdit(props.account);
  } 

  function onDelete(event) {
    event.preventDefault();
    props.onDelete(props.account);
  } 


  return (
    <Row>
      <Col>{MM.getAccountCodeFromType(props.account.acctType)}</Col>
      <Col>{props.account.baseDesc}</Col>
      <Col>{props.account.startingBal}</Col>
      <Col>
        <i className="fas fa-edit" title="Edit" onClick={onEdit}></i>
        <i className="fas fa-trash" title="Delete" onClick={onDelete}></i>
      </Col>
    </Row>
  )
}

export default Accounts;
